import {pushError} from '@js/actions/errorManagement';

export function patchWorkerErrorReporting() {
    if (typeof window === 'undefined' || typeof window.Worker !== 'function' || window.Worker.__errorReportingPatched) {
        return;
    }

    const NativeWorker = window.Worker;

    const describeUrl = (scriptUrl) => {
        try {
            return typeof scriptUrl === 'string' ? scriptUrl : String(scriptUrl);
        } catch {
            return 'unknown';
        }
    };

    const workerLabel = (url) => {
        const path = url.split(/[?#]/)[0];
        const base = path.substring(path.lastIndexOf('/') + 1);
        return base || url;
    };

    class ReportingWorker extends NativeWorker {
        constructor(scriptUrl, options) {
            super(scriptUrl, options);

            const workerUrl = describeUrl(scriptUrl);
            const label = workerLabel(workerUrl);

            this.addEventListener('error', (event) => {
                const rawMessage = event.message || (event.error && event.error.message) || '';
                const location = [event.filename, event.lineno, event.colno]
                    .filter((part) => part !== undefined && part !== null && part !== '')
                    .join(':');
                const sanitized = !event.error && (!rawMessage || rawMessage === 'Script error.');

                const descriptiveMessage = [
                    `Worker error in ${label}`,
                    rawMessage,
                    location && `at ${location}`,
                    sanitized && '(details hidden: cross-origin worker script)'
                ].filter(Boolean).join(' — ');

                let error;
                if (event.error instanceof Error) {
                    error = event.error;
                } else {
                    error = new Error(descriptiveMessage);
                    error.name = 'WorkerError';
                }

                pushError(error, {
                    source: 'web-worker',
                    workerUrl,
                    workerLabel: label,
                    message: rawMessage || undefined,
                    filename: event.filename || undefined,
                    lineno: event.lineno || undefined,
                    colno: event.colno || undefined,
                    sanitized,
                    fingerprint: ['worker-error', label, rawMessage || 'no-message']
                });
            });

            // Structured-clone deserialization failure on an incoming message.
            this.addEventListener('messageerror', () => {
                pushError(new Error(`Worker messageerror in ${label} (message could not be deserialized)`), {
                    source: 'web-worker',
                    workerUrl,
                    workerLabel: label,
                    fingerprint: ['worker-messageerror', label]
                });
            });
        }
    }

    ReportingWorker.__errorReportingPatched = true;
    window.Worker = ReportingWorker;
}
